// Paiper brand tokens — the same warm-paper design system as the landing
// page (HomeScreen.css), shared by the MUI theme and any component that
// needs a raw value (gradients, overlays on imagery, etc.).

export const brand = {
  // Core palette
  cream: '#F5F0E8',
  creamPaper: '#FCFAF6',
  forest: '#1B3A2D',
  forestDeep: '#12291F',
  sage: '#4A7C64',
  sageLight: '#7FA891',
  lightSage: '#E8F0EB',
  copper: '#C47D4E',
  copperLight: '#D4956A',
  charcoal: '#2C2C2C',
  ink: '#22302A',
  warmGray: '#6B6560',

  // Dark mode surfaces (forest-tinted, not pure grey)
  darkBg: '#121814',
  darkPaper: '#1A231E',
  darkPaperRaised: '#222E27',
  darkBorder: 'rgba(245, 240, 232, 0.12)',
  darkTextSecondary: '#A8B0A9',

  border: 'rgba(27, 58, 45, 0.12)',

  // Gradients
  forestGradient: 'linear-gradient(135deg, #1B3A2D 0%, #2E5743 100%)',
  sageGradient: 'linear-gradient(135deg, #4A7C64 0%, #1B3A2D 100%)',
  copperGradient: 'linear-gradient(135deg, #D4956A 0%, #C47D4E 100%)',

  // Typography
  serif: '"DM Serif Display", Georgia, serif',
  sans: '"Plus Jakarta Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',

  // Shadows
  softShadow: '0 4px 24px rgba(27, 58, 45, 0.08)',
  raisedShadow: '0 8px 32px rgba(27, 58, 45, 0.12)',
} as const;

export default brand;
